module.exports = __webpack_public_path__ + "img/dept_1_prod.506feb20.png";